import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/ducks";
import logo from "../../../assets/images/tirezonelogo.webp";

interface LogoProps {
  width?: string | number;
  height?: string | number;
}

const Logo: React.FC<LogoProps> = ({ width = "220px", height = "45px" }) => {
  const user = useSelector((state: RootState) => state?.store?.user);

  const imageSrc =
    user && user !== "guest" && user.pictureImg
      ? `data:image/png;base64,${user.pictureImg}` 
      : logo;

  return (
    <div className="logo">
      <a href="/">
        <img src={imageSrc}  alt="logo"  className="md:max-h-[70px]" />
      </a>
    </div>
  );
};

export default Logo;
